import _axios from '@/utils/request'
const applicationId = '52906a03ce45471fb0e4e72f3132d10f' // 树兰写死
const btnServices = {
    // 按钮列表
    getBtnList (params) {
        return _axios('post', `/ms-shulan-hospital/v1/menu/list_web`, params)
    },
    // 按钮下线
    offBtn (menuId) {
        return _axios('get', `/ms-shulan-hospital/v1/menu/down/${menuId}/${applicationId}`)
    },
    // 按钮上线
    onBtn (menuId) {
        return _axios('get', `/ms-shulan-hospital/v1/menu/up/${menuId}/${applicationId}`)
    },
    // 按钮下移
    moveDownBtn (menuId) {
        return _axios('get', `/ms-shulan-hospital/v1/menu/move_down/${menuId}/${applicationId}`)
    },
    // 按钮上移
    moveUpBtn (menuId) {
        return _axios('get', `/ms-shulan-hospital/v1/menu/move_up/${menuId}/${applicationId}`)
    },
    // 按钮编辑
    updateBtn (param) {
        return _axios('post', `/ms-shulan-hospital/v1/menu/update_menu`, param)
    }
}

export default btnServices
